import { Injectable } from '@angular/core';
import {
  TwainSyncDevicesCommand,
  TwainToDeviceCommand,
  TwainTriggerScanCommand,
} from '@principle-theorem/principle-bridge-core';
import {
  IBridgeDevice,
  IPatient,
  ITwainDevice,
} from '@principle-theorem/principle-core/interfaces';
import {
  DocumentReference,
  Firestore,
  WithRef,
} from '@principle-theorem/shared';
import { BridgeCommandsService } from '../../../bridge-commands.service';

@Injectable()
export class TwainFeatureService {
  constructor(private _bridgeCommands: BridgeCommandsService) {}

  async triggerScan(
    patient: WithRef<IPatient>,
    device: ITwainDevice,
    deviceRef: DocumentReference<IBridgeDevice>
  ): Promise<void> {
    const command: TwainTriggerScanCommand = {
      type: TwainToDeviceCommand.TriggerScan,
      data: {
        patient,
        device,
      },
    };
    await this._bridgeCommands.sendCommand(command, deviceRef);
  }

  async syncDevices(device: WithRef<IBridgeDevice>): Promise<void> {
    await Firestore.patchDoc(device.ref, {
      twainSettings: {
        devices: device.twainSettings?.devices ?? [],
        syncing: true,
      },
    });
    const command: TwainSyncDevicesCommand = {
      type: TwainToDeviceCommand.SyncDevices,
      data: {},
    };
    await this._bridgeCommands.sendCommand(command, device.ref);
  }
}
